export var REQUEST_TYPE = 'Request Type';
export var ZIP_CODE = 'Zip Code';
export var URGENCY = 'Urgency';
export var REQUEST_STATUS = 'Request status';
export var SPECIAL_NEEDS = 'Special Preferences';
export var PROVIDER_SEEN = 'Provider seen';
export var REQUEST_NOTES = 'Request notes';
export var PROVIDER_NAME = 'Provider name';
export var PREFERRED_DISTANCE = 'Preferred distance';
export var DATA_TEST = {
    request_type: 'carePlanDetailsRequestTypeSelect',
    preferred_address: 'carePlanDetailsPreferredAddressNumberInput',
    preferred_distance: 'carePlanDetailsPreferredDistance',
    response_threshold: 'carePlanDetailsResponseThresholdRadio',
    health_issue: 'carePlanDetailsHealthIssueRadio',
    special_needs: 'carePlanDetailsSpecialNeedsRadio',
    first_time_visit: 'carePlanDetailsFirstTimeVisitRadio',
    request_notes: 'carePlanDetailsRequestNotesArea',
    provider_name: 'carePlanDetailsProviderName'
};
export var PREFERRED_DISTANCE_OPTIONS = [
    {
        value: 'any',
        label: 'Any',
        key: 'any'
    },
    {
        value: 'less_than_20_miles',
        label: 'Less than 20 miles',
        key: 'less_than_20_miles'
    },
    {
        value: 'less_than_10_miles',
        label: 'Less than 10 miles',
        key: 'less_than_10_miles'
    },
    {
        value: 'less_than_5_miles',
        label: 'Less than 5 miles',
        key: 'less_than_5_miles'
    },
    {
        value: 'less_than_a_mile',
        label: 'Less than 1 mile',
        key: 'less_than_a_mile'
    }
];
// transformed to match filters
// any filter is skipped as invalid value for filter
export var transformPreferredDistance = function (value) {
    switch (value) {
        case 'less_than_20_miles':
            return 20;
        case 'less_than_10_miles':
            return 10;
        case 'less_than_5_miles':
            return 5;
        case 'less_than_a_mile':
            return 1;
        default:
            return undefined;
    }
};
export var FIRST_TIME_VISIT_OPTIONS = [
    {
        value: true,
        label: 'Yes'
    },
    {
        value: Boolean(''),
        label: 'No'
    }
];
export var RESPONSE_THRESHOLD_OPTIONS = [
    {
        value: 'asap',
        label: 'As soon as possible'
    },
    {
        value: 'one_week',
        label: 'Within 1 week'
    },
    {
        value: 'two_weeks',
        label: 'Within 2 weeks'
    },
    {
        value: 'one_month',
        label: 'Within 1 month'
    },
    {
        value: 'three_months',
        label: 'Within 3 months'
    }
];
export var HEALTH_ISSUE_OPTIONS = [
    {
        value: 'new',
        label: 'New'
    },
    {
        value: 'ongoing',
        label: 'Ongoing'
    },
    {
        value: 'neither',
        label: 'Neither'
    }
];
